import React from 'react';
import Title from '../../atoms/title/title.js';
import Icon from '../../atoms/icon/icon.js';

const FilterTab = ({ type = "filter", title, icon, active = false, onClick }) => {
    const activeColorClass = active ? "mbw-filter-tab-active" : null;
    const renderIcon = () => (icon ? (React.createElement(Icon, { className: `mbw-filter-tab-${type}-icon ${activeColorClass}`, dataTestId: "mbw-filter-tab-icon" }, icon)) : null);
    const renderTitle = () => title ? (React.createElement("div", { "data-testid": "mbw-filter-tab-title", className: `mbw-filter-tab-${type}-title ${activeColorClass}` },
        React.createElement(Title, { fontStyle: "content-small", bold: true }, title))) : null;
    return (React.createElement("button", { "data-testid": "mbw-filter-tab", className: `mbw-filter-tab-${type} ${activeColorClass}`, onClick: onClick },
        renderIcon(),
        renderTitle()));
};

export { FilterTab as default };
//# sourceMappingURL=filter_tab.js.map
